import { render } from "./SiderView.vue?vue&type=template&id=3466c610&scoped=true&ts=true"
import script from "./SiderView.vue?vue&type=script&lang=ts"
export * from "./SiderView.vue?vue&type=script&lang=ts"

import "./SiderView.vue?vue&type=style&index=0&id=3466c610&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3466c610"]])

export default __exports__